import { IAddressLablesResponseData } from "@/api_framework/api_modals/Addresses";
import { IBookingStatusListResponseData } from "@/api_framework/api_modals/Bookings";
import { IEMRStaticUnitsResponseData } from "@/api_framework/api_modals/EMRs";
import { IOrgServicesListResponseData } from "@/api_framework/api_modals/Org";
import {
  ICustomerPetBreedListResponseData,
  IPetGendersResponseData,
  IPetMoodsResponseData,
  IPetSpeciesResponseData,
  IPetStatusResponseData,
} from "@/api_framework/api_modals/Pets";
import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import { IStaticReducerState, StaticReducerStateKeys } from "./reducer_interface";
// Loading the config
// import config from "envConfig";

// Define the initial state using that type
const intialRootState: IStaticReducerState = {
  isStaticDataLoaded: false,
  giant_breeds: [],
  cat_breeds: [],
  dog_breeds: [],
  pet_genders: [],
  address_labels: [],
  pet_moods: [],
  pet_statuses: [],
  pet_species: [],
  org_services: [],
  org_services_for_booking: [],
  org_booking_statuses: [],
  medicine_units: [],
};

export const rootStateSlice = createSlice({
  name: "rootState",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: intialRootState,
  reducers: {
    setOrgBookingStatuses: (
      state,
      action: PayloadAction<{
        data: IBookingStatusListResponseData[];
      }>,
    ) => {
      state.org_booking_statuses = action.payload.data;
    },
    setMedicineUnits: (
      state,
      action: PayloadAction<{
        data: IEMRStaticUnitsResponseData[];
      }>,
    ) => {
      state.medicine_units = action.payload.data;
    },

    setOrgServices: (
      state,
      action: PayloadAction<{
        data: IOrgServicesListResponseData;
      }>,
    ) => {
      state.org_services = action.payload.data;
    },
    setOrgServicesForBooking: (
      state,
      action: PayloadAction<{
        data: IOrgServicesListResponseData;
      }>,
    ) => {
      state.org_services_for_booking = action.payload.data;
    },
    setStaticDataLoaded: (state, action: PayloadAction<boolean>) => {
      state.isStaticDataLoaded = action.payload;
    },

    setAddressLabels: (state, action: PayloadAction<{ data: IAddressLablesResponseData[] }>) => {
      state.address_labels = action.payload.data;
    },
    setPetSpecies: (state, action: PayloadAction<{ data: IPetSpeciesResponseData[] }>) => {
      state.pet_species = action.payload.data;
    },
    setPetGenders: (state, action: PayloadAction<{ data: IPetGendersResponseData[] }>) => {
      state.pet_genders = action.payload.data;
    },
    setPetStatus: (state, action: PayloadAction<{ data: IPetStatusResponseData[] }>) => {
      state.pet_statuses = action.payload.data;
    },
    setPetMoods: (state, action: PayloadAction<{ data: IPetMoodsResponseData[] }>) => {
      state.pet_moods = action.payload.data;
    },
    setBreeds: (
      state,
      action: PayloadAction<{
        key: StaticReducerStateKeys;
        value: ICustomerPetBreedListResponseData[];
      }>,
    ) => {
      state[action.payload.key as "cat_breeds" | "dog_breeds"] = action.payload.value;
    },
  },
});

export const {
  setBreeds,
  setAddressLabels,
  setPetMoods,
  setPetStatus,
  setPetSpecies,
  setPetGenders,
  setStaticDataLoaded,
  setOrgServices,
  setOrgServicesForBooking,
  setOrgBookingStatuses,
  setMedicineUnits,
} = rootStateSlice.actions;

export default rootStateSlice.reducer;
